import styled from 'styled-components';
import {device} from '../../../../theme'

export const SectionWrap = styled.div `
    padding:0;
    padding-bottom: 100px;
    padding-right:40px;
    @media ${device.medium}{
        padding-top: 80px;
        padding-bottom: 80px;
    }
    @media ${device.small}{
        padding-top: 60px;
        padding-bottom: 60px;
    }
    .box-item{
        margin-top: 15px;
    }
    .ts-picks-grid {
      display: -webkit-box; /* Not needed if autoprefixing */
      display: -ms-flexbox; /* Not needed if autoprefixing */
      display: flex;
      margin-left: -30px; /* gutter size offset */
      width: auto;
    }
    .ts-picks-grid_column {
      padding-left: 30px; /* gutter size */
      background-clip: padding-box;
    }
     
    /* Style your items */
    .ts-picks-grid_column > div { /* change div to reference your elements you put in <Masonry> */
      margin-bottom: 30px;
      border-radius:8px;
    }
`;
